export default function Title({ children }) {
    return (
        <h1 className="text-left px-4 font-bold text-xl">{children}</h1>
    );
}